import { ToggleInput } from 'client/components/common/ToggleInput/ToggleInput'
import { Segment } from 'client/Global/Segment'
import { SegmentEvents } from 'client/Global/SegmentEvents'
import { l } from 'client/Other/Translation'
import * as React from 'react'

import { GlobalEvents } from '../../../Other/GlobalEvents'

export const REFERENCE_NUMBER_TYPES_MAP = {
  ISO: 'invoice.referenceNumber.ISO',
  SPY_FI: 'invoice.referenceNumber.SPY_FI',
  SPY_BE: 'invoice.referenceNumber.SPY_BE',
}

export const ReferenceNumberTypeRadio = ({ selectedType, onChange }) => {
  const map = {
    ISO: l(REFERENCE_NUMBER_TYPES_MAP.ISO),
    SPY_FI: l(REFERENCE_NUMBER_TYPES_MAP.SPY_FI),
    SPY_BE: l(REFERENCE_NUMBER_TYPES_MAP.SPY_BE),
  }
  return (
    <ToggleInput
      key="4"
      radio={true}
      name="referenceFieldTypeToggler"
      automation={'referenceFieldTypeToggle'}
      value={selectedType}
      map={map}
      onChange={onChange}
    />
  )
}

const ReferenceFieldsSettings = ({ automation, model, fields, onChangeFields }) => {
  const [menuOpen, setMenuOpen] = React.useState(false)
  const e = React.useRef(null)
  let toggles = null
  const classes = ['ReferenceFieldsSettings', 'ColumnsSettings', 'Controlled', 'Input']

  React.useEffect(() => {
    e.current = GlobalEvents.Click((e) => setMenuOpen(false))
    return () => GlobalEvents.unBind(e.current)
  })

  const referenceFieldsOrderd = model.fields
    .find((field) => {
      return field.name === 'referenceFieldsOrder'
    })
    .default.split(',')

  const selectedFields = () => {
    const selected = []
    referenceFieldsOrderd.forEach((rf) => {
      if (fields[rf] && fields[rf].visible) {
        selected.push(l(`invoiceEditor.${rf}`))
      }
    })
    return selected.length ? selected.join(',') : l('invoiceEditor.referenceFieldsSettings.noReferenceSelected')
  }

  if (menuOpen) {
    toggles = (
      <div className="toggles">
        {referenceFieldsOrderd.map((rf) => {
          return (
            <>
              <div
                className="option"
                key={rf}
                onClick={() => {
                  onChangeFields({
                    ...fields,
                    [rf]: { ...(fields[rf] || { name: rf }), visible: fields[rf] ? !fields[rf].visible : true },
                  })
                  Segment.track(SegmentEvents.experiments.invoiceEditorSettingsChanged, {
                    visible_reference_changed: `${rf} ${fields[rf].visible ? 'removed' : 'added'}`,
                  })
                }}
                data-value={rf}
              >
                <div className={`check ${fields[rf] && fields[rf].visible ? 'checked' : ''}`}> </div>
                <label>{l(`invoiceEditor.${rf}`)}</label>
              </div>
              {rf === 'referenceNumber' && fields[rf].visible && (
                <ReferenceNumberTypeRadio
                  selectedType={fields.paymentReferenceType.value}
                  onChange={(newSelectedType) => {
                    onChangeFields({
                      ...fields,
                      paymentReferenceType: {
                        ...fields.paymentReferenceType,
                        value: newSelectedType,
                      },
                    })
                  }}
                />
              )}
            </>
          )
        })}
      </div>
    )
    classes.push('menuOpen')
  }
  return (
    <div className="subFields">
      <div
        className={classes.join(' ')}
        data-automation={automation}
        data-value={''}
        onClick={(event) => {
          event.stopPropagation()
          GlobalEvents.prevent(e.current)
          return false
        }}
      >
        <span
          className="Label"
          data-automation={automation + '-label'}
          onClick={() => {
            setMenuOpen(!menuOpen)
          }}
        >
          {l('invoiceEditor.ReferenceFieldsSettings')}
        </span>
        <div
          className="values Controlled"
          data-automation={automation + '-value'}
          onClick={() => {
            setMenuOpen(!menuOpen)
          }}
        >
          <span className="values">{selectedFields()}</span>
          <span className="arrow" />
        </div>
        {toggles}
      </div>
    </div>
  )
}

export default ReferenceFieldsSettings
